<mat-tab-group class="custom-mat-tab"
               *ngIf="isReportSectionReady && report && report.dataSections && report.dataSections.length"
               (selectedIndexChange)="onTabIndexChange($event)" [selectedIndex]="selectedFieldSectionIndex">
  <mat-tab *ngFor="let section of report.dataSections; let i = index" label="{{section.header}}">
    <ng-template mat-tab-label>
      <div class="custom-tab-header flex flex-row justify-start items-center">
        <div class="flex flex-col justify-start items-center">
          <div class="headers">{{section.header}}</div>
          <div class="tool-name">{{section.toolName}}</div>
        </div>
      </div>
    </ng-template>
    <div *ngIf="i === selectedFieldSectionIndex" class="content pos-relative m-30 flex flex-col">
      <div *ngIf="section.config.Editor=='EntitySelectorComponent'" class="keno-grid-container">
        <particle-entity-selector [filterId]="section.config.EXECUTION_ID"
                                  [endpointName]="section.config.EndpointName"
                                  [itemType]="section.sectionId"
                                  [filterTemplateId]="section.config.FilterTemplateId"
                                  [invalidateSubject]="invalidateSubjectList[i]"
                                  [leftSourceType]="section.sectionId"
        >
        </particle-entity-selector>
      </div>
      <div *ngIf="section.config.Editor=='DynamicTransferBoxComponent'" class="keno-grid-container">
        <particle-dynamic-transfer-box [filterId]="section.config.EXECUTION_ID"
                                       [invalidateSubject]="invalidateSubjectList[i]"
                                       [leftSourceKey]="section.config.LeftSourceKey"
                                       [rightSourceKey]="section.config.RightSourceKey">
        </particle-dynamic-transfer-box>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
